<template>
  <div
    class="sidebar-settings"
    data-test="graphics-staffSettings"
  >
    <div class="sidebar-settings-title">
      <span>CSS Classes</span>
      <span class="label label-success">STAFF</span>
    </div>

    <div class="sidebar-form-group">
      <textarea
        v-model="cssClasses"
        data-test="graphics-staffSettings-setCssClasses"
        data-entity="graphics-staffSettings-setCssClasses"
      ></textarea>
    </div>
  </div>
</template>

<script>
import settingsMixins from '../../mixins/settings-mixins';

export default {
  mixins: [settingsMixins],
  props: ['element'],
  computed: {
    cssClasses: {
      get() {
        return this.element.cssClasses;
      },
      set(v) {
        this.updateOneElementValue('cssClasses', v);
      },
    },
  },
};
</script>
